var map = {
	"./apple-touch-icon.png": "./src/img/apple-touch-icon.png",
	"./favicon-96x96.png": "./src/img/favicon-96x96.png",
	"./favicon.ico": "./src/img/favicon.ico",
	"./favicon.svg": "./src/img/favicon.svg",
	"./font-awesome/angle-right-regular-full.svg": "./src/img/font-awesome/angle-right-regular-full.svg",
	"./font-awesome/arrow-up-regular-full.svg": "./src/img/font-awesome/arrow-up-regular-full.svg",
	"./font-awesome/bars-solid-full.svg": "./src/img/font-awesome/bars-solid-full.svg",
	"./font-awesome/check-solid-full.svg": "./src/img/font-awesome/check-solid-full.svg",
	"./font-awesome/chevron-down-regular-full.svg": "./src/img/font-awesome/chevron-down-regular-full.svg",
	"./font-awesome/chevron-down-solid-full.svg": "./src/img/font-awesome/chevron-down-solid-full.svg",
	"./font-awesome/house-regular-full.svg": "./src/img/font-awesome/house-regular-full.svg",
	"./font-awesome/language-regular-full.svg": "./src/img/font-awesome/language-regular-full.svg",
	"./font-awesome/location-crosshairs-regular-full.svg": "./src/img/font-awesome/location-crosshairs-regular-full.svg",
	"./font-awesome/magnifying-glass-regular-full.svg": "./src/img/font-awesome/magnifying-glass-regular-full.svg",
	"./font-awesome/paper-plane-regular-full.svg": "./src/img/font-awesome/paper-plane-regular-full.svg",
	"./font-awesome/pause-solid-full.svg": "./src/img/font-awesome/pause-solid-full.svg",
	"./font-awesome/play-solid-full.svg": "./src/img/font-awesome/play-solid-full.svg",
	"./font-awesome/sliders-regular-full.svg": "./src/img/font-awesome/sliders-regular-full.svg",
	"./font-awesome/xmark-solid-full.svg": "./src/img/font-awesome/xmark-solid-full.svg",
	"./icon-checks.svg": "./src/img/icon-checks.svg",
	"./icon-strl-white.svg": "./src/img/icon-strl-white.svg",
	"./icon-stuurlui-blue.svg": "./src/img/icon-stuurlui-blue.svg",
	"./icon-stuurlui-global.svg": "./src/img/icon-stuurlui-global.svg",
	"./logo-shape.svg": "./src/img/logo-shape.svg",
	"./logo.svg": "./src/img/logo.svg",
	"./shape-header-home.svg": "./src/img/shape-header-home.svg",
	"./site.webmanifest": "./src/img/site.webmanifest",
	"./strl-16px.png": "./src/img/strl-16px.png",
	"./strl-36px.png": "./src/img/strl-36px.png",
	"./web-app-manifest-192x192.png": "./src/img/web-app-manifest-192x192.png",
	"./web-app-manifest-512x512.png": "./src/img/web-app-manifest-512x512.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";